import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalService } from '../../shared/services/global/global.service';
import { AdminService } from 'src/app/business-service/admin/admin.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { UserOrgDetailsComponent } from './user-org-details/user-org-details.component';
import { BrandDetailsComponent } from './brand-details/brand-details.component';
import { SubscriptionSelectionComponent } from './subscription-selection/subscription-selection.component';
import { ModulesAccessComponent } from './modules-access/modules-access.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-organization-form',
  templateUrl: './organization-form.component.html',
  styleUrls: ['./organization-form.component.scss'],
})
export class OrganizationFormComponent implements OnInit {

  @ViewChild(UserOrgDetailsComponent) userOrgDetailsComponent!: UserOrgDetailsComponent;
  @ViewChild(BrandDetailsComponent) brandDetailsComponent!: BrandDetailsComponent;
  @ViewChild(SubscriptionSelectionComponent) subscriptionSelectionComponent!: SubscriptionSelectionComponent;
  @ViewChild(ModulesAccessComponent) modulesAccessComponent!: ModulesAccessComponent;

  organizationId: any;
  editOrganizationId: any;

  entireOrganizationDetails: any;

  // Sections form data
  organizationDetailsFormData: any;
  brandDetailsFormData: any;
  packageFormData: any;
  accessModulesFormData: any;

  orderOfTabs: string[] = ['details', 'brand', 'subscriptions', 'access'];
  orderOfTabsIndex: number = 0;
  componentView: string = this.orderOfTabs[this.orderOfTabsIndex];

  @Input() isUserEditing: boolean = false;

  constructor(
    private _modalController: ModalController,
    private _globalService: GlobalService,
    private _adminService: AdminService,
    private _responseNotificationService: ResponseNotificationService,
    private _reloadService: ComponentReloadService,
    private _router: Router
  ) { }

  async ngOnInit() {
    if (this.editOrganizationId) {
      this.entireOrganizationDetails = await this.getOrganizationData(this.editOrganizationId);
      this.assignOrganizationDetails();
      this.assignOrganizationId(this.entireOrganizationDetails?.organizationId);
      this.editOrganizationId = this.entireOrganizationDetails?.organizationId
    }
  }


  assignOrganizationDetails() {
    let organizationdata = {
      organizationDetails: this.entireOrganizationDetails?.organizationDetails,
      userDetails: this.entireOrganizationDetails?.userDetails?.userDetail,
      domainSettings: this.entireOrganizationDetails?.domainSettings,
      accountManager: this.entireOrganizationDetails?.accountManager
    }
    this.organizationDetailsFormData = organizationdata ?
      { ...this.organizationDetailsFormData, ...organizationdata } : null;

    this.brandDetailsFormData = this.entireOrganizationDetails?.organizationBrand ?
      { ...this.brandDetailsFormData, ...this.entireOrganizationDetails?.organizationBrand } : null;
    
    if(this.brandDetailsFormData){
      this.brandDetailsFormData.showManualReviews = this.entireOrganizationDetails?.googlePlaceInfo?.showManualReviews;
      this.brandDetailsFormData.showReviewsInTemplate = this.entireOrganizationDetails?.googlePlaceInfo?.showReviewsInTemplate;
    }    

    if (this.entireOrganizationDetails?.organizationDetails?.packageId) {
      let packageData = {
        packageIds: this.entireOrganizationDetails?.organizationDetails?.packageId,
        startDate: this.entireOrganizationDetails?.organizationDetails?.startDate,
        endDate: this.entireOrganizationDetails?.organizationDetails?.endDate,
      }

      this.packageFormData = packageData ?
        { ...this.packageFormData, ...packageData } : null;
    }

    if (this.entireOrganizationDetails?.modules) {
      let modulesData = {
        modules: this.entireOrganizationDetails?.modules,
        travelIntegration: this.entireOrganizationDetails?.travelIntegration
      }
      this.accessModulesFormData = modulesData ?
        { ...this.accessModulesFormData, ...modulesData } : null;
    }
    this.makeAvalibleTabsGreen();
  }

  makeAvalibleTabsGreen() {
    if (this.organizationDetailsFormData) {
      this.organizationDetailsFormData.dataSaved = true;
    }
    if (this.brandDetailsFormData) {
      this.brandDetailsFormData.dataSaved = true;
    }
    if (this.packageFormData) {
      this.packageFormData.dataSaved = true;
    }
    if (this.accessModulesFormData) {
      this.accessModulesFormData.dataSaved = true;
    }
  }

  async getOrganizationData(organizationId: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._adminService.getOrganization(organizationId).subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          console.error("Error while fetching organization details", error);
          reject(error);
        }
      });
    })
  }

  closeModal() {
    this._modalController.dismiss();
  }

  async onViewChangeFromTab(view: string) {
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if (await this.saveDataOfCurrentForm(this.componentView)) {
            this.changeComponentView(view);
          } else {
          }
          break
        }
        case 'proceed': {
          this.changeComponentView(view);
          break;
        }
      }
    } else {
      this.changeComponentView(view);
    }
  }

  changeComponentView(view: any) {
    this.componentView = view;
    this.orderOfTabsIndex = this.orderOfTabs.indexOf(view);
  }

  async onViewChange(goPrevious: any) {
    if (goPrevious) {
      this.orderOfTabsIndex--;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    } else {
      this.orderOfTabsIndex++;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    }
  }

  checkCurrentFormDirty(view: any): any {
    switch (view) {
      case 'details': {
        return (this.userOrgDetailsComponent?.formDataModified());
      }
      case 'brand': {
        return (this.brandDetailsComponent?.formDataModified());
      }
      case 'subscriptions': {
        return (this.subscriptionSelectionComponent?.formDataModified());
      }
      case 'access': {
        return (this.modulesAccessComponent?.formDataModified());
      }
      default: {
        return false;
      }
    }
  }

  async saveDataOfCurrentForm(view: any) {
    switch (view) {
      case 'details': {
        return (this.userOrgDetailsComponent?.onSubmit());
      }
      case 'brand': {
        return (this.brandDetailsComponent?.onSubmit());
      }
      case 'subscriptions': {
        return (this.subscriptionSelectionComponent?.onSubmit());
      }
      case 'access': {
        return (this.modulesAccessComponent?.onSubmit());
      }
      default: {
        return false;
      }
    }
  }

  assignOrganizationId(id: any) {
    this.organizationId = id;
  }

  storeOrgDetailsData(formData: any) {
    this.organizationDetailsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeBrandDetailsData(formData: any) {
    this.brandDetailsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storePackageData(formData: any) {
    this.packageFormData = {
      ...formData, dataSaved: true,
      dataInvalid: false
    }
  }
  storeAccessModulesData(formData: any) {
    this.accessModulesFormData = {
      ...formData, dataSaved: true,
      dataInvalid: false
    }
  }


  // Submit function
  async onSubmit(): Promise<boolean> {
    const formData = await this.serializeOrganizationData();
    if (this.editOrganizationId) {
      return new Promise((resolve) => {
        this._adminService.updateOrganizationDetails(this.editOrganizationId, formData).subscribe({
          next: async (data: any) => {
            this.entireOrganizationDetails = data;
            const uploadedLogo = this.brandDetailsFormData?.imageFile
            if (uploadedLogo instanceof File) {
              await this.uploadOrganizationLogo(uploadedLogo, this.organizationId);
            }
            this.assignOrganizationId(data.organizationId);
            this.editOrganizationId = data.organizationId
            this.assignOrganizationDetails();
          },
          error: (error) => {
            console.error('Error updating organization: ', error);
            this._responseNotificationService.showMessage("Error updating Organization", true);
            resolve(false);
          },
          complete: () => {
            this._responseNotificationService.showMessage("Organization updated successfully");
            this._reloadService.triggerOrganizationReload();
            resolve(true);
          }
        });
      });
    } else {
      return new Promise((resolve) => {
        this._adminService.addOrganization(formData).subscribe({
          next: async (data: any) => {
            this.entireOrganizationDetails = data;
            const uploadedLogo = this.brandDetailsFormData?.imageFile
            if (uploadedLogo instanceof File) {
              await this.uploadOrganizationLogo(uploadedLogo, this.organizationId);
            }
            this.assignOrganizationId(data.organizationId);
            this.assignOrganizationDetails();
            this.editOrganizationId = data.organizationId
          },
          error: (error) => {
            console.error('Error saving organization: ', error);
            this._responseNotificationService.showMessage("Error saving Organization", true);
            resolve(false);
          },
          complete: () => {
            this._responseNotificationService.showMessage("Organization added successfully");
            this._reloadService.triggerOrganizationReload();
            resolve(true);
          }
        });
      });
    }
  }

  async uploadOrganizationLogo(logo: File, organizationId: string): Promise<boolean> {
    try {
      let data = new FormData();
      data.append('image', logo);
      let res = await this._adminService.uploadOrganizationLogo(data, organizationId).toPromise();
      this.entireOrganizationDetails.organizationBrand.imagePath = res;
      
      return true;
    } catch (error) {
      console.error("Error while uploading logo", error);
      this._responseNotificationService.showMessage("Failed to upload logo, please try again.", true);
      return false;
    }
  }

  showReview($event: any) {
    this.closeModal();
    if (!this.isUserEditing) {
      this._router.navigate([`admin/organization/${this.organizationId}`]);
    }
  }

  serializeOrganizationData() {
    let googlePlaceInfo = this.entireOrganizationDetails?.googlePlaceInfo;
    if(googlePlaceInfo){
      googlePlaceInfo.showReviewsInTemplate = this.brandDetailsFormData ? this.brandDetailsFormData.showReviewsInTemplate : googlePlaceInfo.showReviewsInTemplate;
      googlePlaceInfo.showManualReviews = this.brandDetailsFormData ? this.brandDetailsFormData.showManualReviews : googlePlaceInfo.showManualReviews;
    }
    const serializedData = {
      organizationDetails: {
        ...this.organizationDetailsFormData?.organizationDetails,
        packageId: this.packageFormData?.packageIds || null,
        startDate: this.packageFormData?.startDate ? this.packageFormData?.startDate : new Date(),
        endDate: this.packageFormData?.endDate ? this.packageFormData?.endDate : new Date(),
      },
      userDetails: {
        userDetail: this.organizationDetailsFormData?.userDetails,
      },
      domainSettings: this.organizationDetailsFormData?.domainSettings,
      accountManager: this.organizationDetailsFormData?.accountManager,
      organizationBrand: this.brandDetailsFormData ? { ...this.brandDetailsFormData } : null,
      modules: this.accessModulesFormData?.modules || null,
      travelIntegration: this.accessModulesFormData?.travelIntegration,
      googlePlaceInfo: googlePlaceInfo || null,
      id: this.entireOrganizationDetails?.id || null,
      userId: this.entireOrganizationDetails?.userId || null,
      ownershipRole: this.entireOrganizationDetails?.ownershipRole,
      organizationId: this.entireOrganizationDetails?.organizationId || null
    }

    return serializedData;
  }

}
